<template>
  <!-- 只读名单弹窗:详情页展示课程已选的学生/老师(走 *_ChooseList 接口) -->
  <el-dialog :visible.sync="visible" :title="`已选${unitName}名单`" width="620px" :fullscreen="isMobile"
    :close-on-click-modal="false" append-to-body @open="handleOpen">
    <div class="proster">
      <div class="proster-head">
        <el-input v-model="keyword" size="small" :placeholder="`搜索姓名 / ${numberLabel}`" clearable
          @keyup.enter.native="handleSearch" @clear="handleSearch"></el-input>
        <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
        <span class="proster-total">共 {{ total }} 人</span>
      </div>
      <div class="proster-table" v-loading="loading">
        <custom-table :data="list" border style="width: 100%">
          <custom-table-column type="index" label="序号" width="70"></custom-table-column>
          <custom-table-column prop="name" label="姓名" min-width="120"></custom-table-column>
          <custom-table-column prop="number" :label="numberLabel" min-width="140"></custom-table-column>
        </custom-table>
      </div>
      <div class="pageLine">
        <PageLine :total="total" ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import PageLine from '@/components/page.vue';
import CustomTable from '@/components/CustomTable';
import CustomTableColumn from '@/components/CustomTableColumn';

export default {
  name: 'PersonRosterDialog',
  components: {
    PageLine,
    CustomTable,
    CustomTableColumn,
  },
  props: {
    // student 学生 / teacher 老师
    type: {
      type: String,
      default: 'student',
    },
    // 课程 id(接口按课程取已选名单)
    courseId: {
      type: [String, Number],
      default: '',
    },
  },
  // 详情页外层 el-form 是 disabled 的,断开注入,弹窗内按钮/输入才能用
  provide() {
    return { elForm: { disabled: false } };
  },
  data() {
    return {
      visible: false,
      isMobile: false,
      keyword: '',
      list: [],
      total: 0,
      loading: false,
    };
  },
  computed: {
    unitName() {
      return this.type === 'teacher' ? '老师' : '学生';
    },
    numberLabel() {
      return this.type === 'teacher' ? '工号' : '学号';
    },
    listUrl() {
      return this.type === 'teacher' ? 'api/new_course/teacherChooseList' : 'api/new_course/studentChooseList';
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    // 父组件(选择器)在详情模式点「查看名单」时调用
    open() {
      this.visible = true;
    },
    handleOpen() {
      this.keyword = '';
      this.list = [];
      this.total = 0;
      // 弹窗首次打开时 PageLine 才渲染,页码重置放 nextTick
      this.$nextTick(() => {
        if (this.$refs.pageChild) this.$refs.pageChild.page = 1;
        this.getList();
      });
    },
    async getList() {
      this.loading = true;
      const page = this.$refs.pageChild ? this.$refs.pageChild.page : 1;
      const size = this.$refs.pageChild ? this.$refs.pageChild.size : 10;
      const params = {
        course_id: this.courseId,
        page,
        size,
        keyword: this.keyword,
      };
      const res = await this.$api.instance.interfaceServer(this.listUrl, 'get', this.$until.deleteNullPrototype(params));
      this.loading = false;
      if (res.code == 0 && res.data) {
        this.list = res.data.data || [];
        this.total = res.data.total || 0;
      } else {
        this.list = [];
        this.total = 0;
      }
    },
    handleSearch() {
      this.$nextTick(() => {
        if (this.$refs.pageChild) this.$refs.pageChild.page = 1;
        this.getList();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.proster-head {
  display: flex;
  align-items: center;
  gap: 8px;

  .el-input {
    flex: 1;
  }

  .proster-total {
    color: #909399;
    white-space: nowrap;
  }
}

/* 表格样式交给 custom-table:桌面渲染 el-table,窄屏自动切卡片列表 */
.proster-table {
  margin-top: 10px;
  min-height: 260px;
}

.proster-pager,
.pageLine {
  margin-top: 8px;
  text-align: right;
}
</style>
